import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import styles from './AutoReplyDeleteWarning.module.css';
import warningImage from '../../../../../assets/images/warning.svg';
import { useRootStore } from '../../../../../mobx/bridge';
import PopperWrapper from '../../PopperWrapper/PopperWrapper';

// eslint-disable-next-line prefer-arrow-callback,sonarjs/cognitive-complexity
const AutoReplyDeleteWarning = observer(function AutoReplyDeleteWarning(props) {
  const { sendingEvents } = useRootStore();
  const { data, onClose, selectedDeleteButton } = props;
  const { t } = useTranslation();

  const isDeleteWarningOpen = Boolean(selectedDeleteButton);

  const confirmAutoReplySet = () => {
    sendingEvents.socketEmitDeleteAutoReply(data);
    onClose();
  };

  return (
    <PopperWrapper
      isOpen={isDeleteWarningOpen}
      anchorEl={selectedDeleteButton}
      arrow
      arrowDirection="left"
      onClose={onClose}
      containerClass={styles.positionFix}
    >
      <Grid
        component="div"
        container
        justify="center"
        alignItems="center"
        className={styles.container}
      >
        <Grid component="div" container item xs={12} justify="center" alignItems="center">
          <img src={warningImage} alt={t('Common.Warning')} className={styles.warningImage} />
        </Grid>
        <Grid component="div" container item xs={12} justify="center" alignItems="center">
          <span className={styles.warningLabel}>{t('Common.Warning')}</span>
        </Grid>
        <Grid component="div" container item xs={12} justify="center" alignItems="center">
          <span className={styles.warningText}>
            {data.IsActiveForTextChat || data.IsActiveForWebChat
              ? t('AutoReplyEditButtons.ConfirmDeleteMessageActive')
              : t('AutoReplyEditButtons.ConfirmDeleteMessage')}
          </span>
        </Grid>
        <Grid
          component="div"
          container
          item
          xs={12}
          justify="center"
          alignItems="center"
          className={styles.buttonContainer}
        >
          <button
            type="button"
            className={[styles.btn, styles.continueBtn].join(' ')}
            onClick={confirmAutoReplySet}
          >
            {t('Common.Continue')}
          </button>
          <button
            type="button"
            className={[styles.btn, styles.cancelBtn].join(' ')}
            onClick={onClose}
          >
            {t('Common.Cancel')}
          </button>
        </Grid>
      </Grid>
    </PopperWrapper>
  );
});
AutoReplyDeleteWarning.whyDidYouRender = true;
AutoReplyDeleteWarning.displayName = 'AutoReplyDeleteWarning';

export default AutoReplyDeleteWarning;
